export const EYE_SPACING: number = 100
export const EYE_RADIUS: number = 40
export const Y_OFFSET: number = -70
export const STROKE_WIDTH: number = 4
export const EYEBROW_WIDTH: number = 70
export const EYEBROW_HEIGHT: number = 15
